<nz-badge [nzCount]="(failingRuleCount$ | async) ?? undefined">
  <button nz-button (click)="openValidationModal()" nzType="primary">
    <i nz-icon nzType="warning"></i>
    <span class="em-screen-large">Validations</span>
  </button>
</nz-badge>
